<div class="container-fluid">
  <page-header-search
    [isSearchInput]="true"
    [pageTitleValue]="pageTitle"
    placeholderValue="Search by patient name or mobile number or Psp Code …"
    (onHeaderSearchSubmit)="onSearchPatients($event)"
    [searchString]="searchValue"
  >

  </page-header-search>

  <div class="card">
    <div class="card-header border-0 pt-0 pb-0">
      <div class="row align-items-center">
        <div class="table-title mb-1">
          <div class="table-title-actions">
            <button class="btn btn-neutral" (click)="ExportTOExcel()">
              <span class="btn-inner--icon">
                <i class="ni ni-cloud-download-95"> </i>
              </span>
              <span class="btn-inner--text"> Download as Excel </span>
            </button>
          </div>

          <!-- <div class="table-title-actions" >
            <app-page-header-selections class="mb-0"
               [pageId]="pageSelectionId"
               (pageChanged)="changePageId($event)">
              <button class="btn btn-neutral" (click)="ExportTOExcel()">
                <span class="btn-inner--icon">
                  <i class="ni ni-cloud-download-95"> </i>
                </span>
                <span class="btn-inner--text"> Download as Excel </span>
              </button>
            </app-page-header-selections>
          </div> -->

          <span>
            <a (click)="invertSorting()">
              <span>↑</span>
              <span class="ml--1">↓</span>
              Sort By
            </a>
          </span>
        </div>
      </div>
    </div>
    <div class="card-body">
      <ngx-datatable class="material ngx-datatable-custom" [rows]="requestArray"
        [columns]="columns" [limit]="apiParams.pageSize" [offset]="apiParams.page-1"
        columnMode="force" externalPaging="true" [count]="totalItems" [scrollbarH]="true"
        [headerHeight]="50" [footerHeight]="50" rowHeight="auto" (page)="onChangePage($event)"
        selectionType="single" externalPaging="true" [messages]="messages">
        
      </ngx-datatable>
    </div>
  </div>
</div>
<ngx-spinner></ngx-spinner>
